import { FormSubmitStatus, getFinisherOutput, type SubmitResult } from '@hmmh/storyblok-forms/client';
import { MEDICE_QR_CODE_FINISHER_KIND, type MediceQrCodeFinisherOutput } from '@medice/storyblok-forms-nuxt/qr-code';

const SVG_DATA_URL = /^data:image\/svg\+xml;base64,[A-Za-z0-9+/]+={0,2}$/;
const PNG_DATA_URL = /^data:image\/png;base64,[A-Za-z0-9+/]+={0,2}$/;

export interface QrCode {
    svgDataUrl: string;
    pngDataUrl?: string;
}

/**
 * Reads the QR code finisher output of a successful submission. Only base64
 * image data URLs are accepted, so nothing else can end up in `src` or `href`.
 */
export const getQrCode = (result: SubmitResult | undefined): QrCode | undefined => {
    if (result?.status !== FormSubmitStatus.SUCCESS) return undefined;

    const output: Partial<Record<keyof MediceQrCodeFinisherOutput, unknown>> | undefined =
        getFinisherOutput<MediceQrCodeFinisherOutput>(result.finishers, MEDICE_QR_CODE_FINISHER_KIND);

    const svgDataUrl = output?.svgDataUrl;
    if (typeof svgDataUrl !== 'string' || !SVG_DATA_URL.test(svgDataUrl)) return undefined;

    const pngDataUrl = output?.pngDataUrl;
    return typeof pngDataUrl === 'string' && PNG_DATA_URL.test(pngDataUrl)
        ? { svgDataUrl, pngDataUrl }
        : { svgDataUrl };
};
